var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04134 19.2974L16.8688 11.4699L19.5297 14.1308L11.7022 21.9583H9.04134V19.2974ZM15.4997 25.8333C18.2402 25.8333 20.8686 24.7446 22.8064 22.8067C24.7443 20.8688 25.833 18.2405 25.833 15.4999C25.833 12.7593 24.7443 10.131 22.8064 8.19315C20.8686 6.25527 18.2402 5.16659 15.4997 5.16659C12.7591 5.16659 10.1308 6.25527 8.1929 8.19315C6.25503 10.131 5.16634 12.7593 5.16634 15.4999C5.16634 18.2405 6.25503 20.8688 8.1929 22.8067C10.1308 24.7446 12.7591 25.8333 15.4997 25.8333ZM21.5705 12.077L20.2788 13.3687L17.6309 10.7208L18.9226 9.42909C19.1938 9.14492 19.6459 9.14492 19.9172 9.42909L21.5705 11.0824C21.8547 11.3537 21.8547 11.8058 21.5705 12.077ZM15.4997 2.58325C17.1959 2.58325 18.8755 2.91735 20.4427 3.56647C22.0098 4.2156 23.4337 5.16703 24.6331 6.36646C25.8326 7.56588 26.784 8.9898 27.4331 10.5569C28.0822 12.124 28.4163 13.8037 28.4163 15.4999C28.4163 18.9256 27.0555 22.211 24.6331 24.6334C22.2108 27.0557 18.9254 28.4166 15.4997 28.4166C13.8034 28.4166 12.1238 28.0825 10.5567 27.4334C8.98956 26.7842 7.56564 25.8328 6.36621 24.6334C3.94387 22.211 2.58301 18.9256 2.58301 15.4999C2.58301 12.0742 3.94387 8.7888 6.36621 6.36646C8.78856 3.94411 12.074 2.58325 15.4997 2.58325Z",
    fill: "#004225"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.11a2765bc449f532184da77b44c88fab.svg";
export { ForwardRef as ReactComponent };